import { Component, OnInit, Input } from '@angular/core';
import { Departement } from '../../models/departement';

@Component({
  selector: 'app-statistics-image',
  templateUrl: './stats-image.component.html',
  styleUrls: ['./stats-image.component.scss'],
})
export class StatsImage implements OnInit {
  @Input() selectedDepartement ?: Departement;

  ngOnInit(): void {}
}

